const root = '/user-access-control';

export const userAccessRoutes = {
  root,
  tracking: '/tracking/select',
  createUser: `${root}/editUser`,
  userFormPattern: `${root}/editUser/:id?`,
  editUserPattern: `${root}/editUser/:id`,
  userDetailsPattern: `${root}/user/:id`,
  userDetails: (userId: number) => `${root}/user/${userId}`,
  editUser: (userId: number) => `${root}/editUser/${userId}`,
} as const;
